import React from 'react';

const Donate = () => {
  return (
    <section id="donate" className="donate-light">
      <div className="container">
        <div className="donate-content-light">
          <h2>Support Our Mission</h2>
          <p>Your donation helps us provide essential resources, education, and housing for children with autism in the Maasai community.</p>
          <a 
            href="https://shop.directpay.online//paymybills/NENGAIFOUNDATION" 
            className="donate-button-light"
            target="_blank"
            rel="noopener noreferrer"
          >
            DONATE NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default Donate;